import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type FlightState } from './state'

export const useFlightStore = defineStore('flight', {
  state: useState,
  getters: { ...Getters },
  actions: { ...Actions },
})

export type FlightStoreContext = ReturnType<typeof useFlightStore>